/* eslint-disable @typescript-eslint/no-use-before-define */
import * as React from 'react';
import styled from 'styled-components';

import { Divider } from 'components';
import { useBreakpoint } from 'hooks';
import ListingAndStopSearch from './ListingAndStopSearch';
import RouteList from './RouteList';
import RouteListHeader from './RouteListHeader';
import SendRequests from './SendRequests';

const RouteListComponent: React.FC = () => {
  const { md } = useBreakpoint();

  return (
    <StyledRouteListComponent>
      <StyledDivider $md={md} />
      <RouteListHeader />
      <ListingAndStopSearch />
      <StyledListBackground $md={md}>
        <RouteList />
        {md && <SendRequests />}
      </StyledListBackground>
    </StyledRouteListComponent>
  );
};

export default RouteListComponent;

const StyledRouteListComponent = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
`;

const StyledDivider = styled(Divider)<{ $md: boolean }>`
  margin: 16px auto;
  min-width: 90%;
  width: ${({ $md }) => ($md ? '90%' : '96%')};
`;

const StyledListBackground = styled.div<{
  $md: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f0f2f5;
  flex: 1;
  margin-top: 16px;
  ${({ $md }) => ($md ? 'min-height: 0;' : 'padding-bottom: 80px;')}
`;
